module.exports = __webpack_public_path__ + "img/bio.3f074601.jpg";